import AdminDeleteButton from '../../common/AdminDeleteButton';
import React from 'react';
import { Link, withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import Paginations from '../../common/paginations';
import constant from '../../../constant';
import moment from 'moment';

const ProjectList = ({ data, setCurrentPage, limit, onChangeVisibility }) => {
    const { projects, total, page } = data;

    return (
        <React.Fragment>
            <div className="table-responsive">
                <table className="table align-middle table-hover">
                    <thead className="table-light">
                        <tr>
                            <th scope="col" style={{ width: 70 }}>
                                ID
                            </th>
                            <th scope="col">Project Details</th>
                            <th scope="col">Project Manager</th>
                            <th scope="col">Other Information </th>
                            <th scope="col">Start {'<>'} End Date</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {projects?.length > 0 ? (
                            projects.map((item, index) => (
                                <React.Fragment>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontSize: 15, fontFamily: "nunito" }}>
                                            {item.ID || 'NA'}
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0)" className="text-dark">
                                                    {item.PROJECT_NAME} - {item.PROJECT_CODE}
                                                </a>
                                            </h5>

                                            <p className="text-muted mb-0">
                                                Company : {
                                                    item.COMPANY_NAME}
                                            </p>
                                            <p className="text-muted mb-0">
                                                Shipyard : {
                                                    item.SHIPYARD_NAME}
                                            </p>
                                            <p className="text-muted mb-0">
                                                Status : {
                                                    item.IS_ACTIVE ? (
                                                        item.END_DATE ? (
                                                            new Date(item.END_DATE) < new Date() ? (
                                                                <span style={{ color: "rgb(7, 112, 42)" }}>Completed</span>
                                                            ) : (
                                                                <span style={{ color: "#ab5858" }}>In Progress</span>
                                                            )
                                                        ) : (
                                                            <span style={{ color: "#ab5858" }}>In Progress</span>
                                                        )
                                                    ) : (
                                                        <span style={{ color: "#ab5858" }}>Inactive</span>
                                                    )
                                                }
                                            </p>


                                            <p className="text-muted mb-0">
                                                <span style={{ color: "#f46a6a" }}>Last Updated</span> | {moment(item.MODIFIED_ON).format('DD-MM-YYYY')}{" "}
                                            </p>
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                {item.PROJECT_MANAGER_NAME}
                                            </h5>
                                        </td>
                                        <td>
                                            <p className="text-muted mb-0">
                                                •{" "}
                                                <a href={constant.Authedcomponent.listShipMasterData.url} className="text-dark">
                                                    <span style={{ color: "#2b5a7e" }}>Hulls ({item.hull_count})</span>
                                                </a>
                                                <br />•{" "}
                                                <a href={constant.Authedcomponent.schedulePreview.url} className="text-dark">
                                                    <span style={{ color: "#2b5a7e" }}>Schedule ({item.schedule_count})</span>
                                                </a>
                                                <br />•{" "}
                                                <a href={constant.Authedcomponent.projectDocumentCount.url} className="text-dark">
                                                    <span style={{ color: "#2b5a7e" }}>Documents ({item.document_count})</span>
                                                </a>
                                                <br />•{" "}
                                                <a href={constant.Authedcomponent.inspectionIndex.url} className="text-dark">
                                                    <span style={{ color: "#2b5a7e" }}>Inspections ({item.inspection_count})</span>
                                                </a>
                                                <br />•{" "}
                                                <a href={constant.Authedcomponent.ncrIndex.url} className="text-dark">
                                                    <span style={{ color: "#2b5a7e" }}>NCR ({item.ncr_count})</span>
                                                </a>
                                                <br />•{" "}
                                                <a href={constant.Authedcomponent.planApprovalIndex.url} className="text-dark">
                                                    <span style={{ color: "#2b5a7e" }}>Plan Approval ({item.plan_approval_count})</span>
                                                </a>



                                            </p>
                                        </td>
                                        <td>
                                            <p className="mb-1">
                                                Start : {item.START_DATE || 'NA'}
                                            </p>
                                            <p className="mb-0">
                                                End : {item.END_DATE || 'NA'}
                                            </p>
                                        </td>

                                        <td>
                                            <ul className="list-inline font-size-20 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href="javascript: void(0);"
                                                        title="View Project"
                                                        data-bs-toggle="modal"
                                                        data-bs-target={`#projectModal-${item.ID}`}
                                                    >
                                                        <i className="bx bxs-zoom-in" />
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <Link
                                                        to={{
                                                            pathname: constant.Authedcomponent.editProject.url,
                                                            state: {
                                                                data: btoa(JSON.stringify(item)),
                                                                page: page,
                                                            },
                                                        }}
                                                        title="Edit"
                                                    >
                                                        <i className="bx bx-edit"></i>
                                                    </Link>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <Link
                                                        to={{
                                                            pathname: constant.Authedcomponent.assignVesselsToProject.url,
                                                            state: {
                                                                data: btoa(JSON.stringify(item)),
                                                                page: page,
                                                            },
                                                        }}
                                                        title="Assign Vessels"
                                                    >
                                                        <i className="bx bx-select-multiple"></i>
                                                    </Link>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href="javascript:void(0);"
                                                        onClick={() => onChangeVisibility(item)}
                                                        style={{ color: "red" }}
                                                        title="Delete Project"
                                                    >
                                                        <i className={`bx ${item.IS_ACTIVE ? 'bx-trash' : 'bx-undo'}`} />
                                                    </a>
                                                </li>
                                            <li className="list-inline-item px-2"><AdminDeleteButton resource="project" entryId={item.ID} label="project" /></li>
                                            </ul>

                                        </td>
                                    </tr>
                                    <div
                                        className="modal fade"
                                        id={`projectModal-${item.ID}`}
                                        data-bs-backdrop="static"
                                        data-bs-keyboard="false"
                                        tabIndex={-1}
                                        role="dialog"
                                        aria-labelledby="projectModalLabel"
                                        aria-hidden="true"
                                    >
                                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title">Project Details</h5>
                                                    <button type="button" className="btn-close" data-bs-dismiss="modal" />
                                                </div>
                                                <div className="modal-body">
                                                    <table className="table table-striped mb-0">
                                                        <tbody>
                                                            <tr>
                                                                <td>Project</td>
                                                                <td>{item.PROJECT_NAME} - {item.PROJECT_CODE}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Project Manager</td>
                                                                <td>{item.PROJECT_MANAGER_NAME}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Contract On</td>
                                                                <td>{moment(item.START_DATE).format('DD MMM, YYYY')}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Last Updated</td>
                                                                <td>{moment(item.MODIFIED_ON).format('DD MMM, YYYY')}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Description</td>
                                                                <td>{item.DESCRIPTION}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>

                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center">
                                    No Projects found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Paginations
                limit={limit}
                totalCount={total}
                range={5}
                currentPage={page}
                onPageChange={setCurrentPage}
            />
        </React.Fragment>
    );
};

export default withRouter(ProjectList);
